(function () {
  const STORAGE_KEY = 'atlas-welcome-popup-dismissed';
  const root = document.querySelector('[data-welcome-popup]');
  if (!root) return;

  const dialog = root.querySelector('[data-welcome-dialog]');
  const delayMs = Number(root.dataset.delay || 4) * 1000;
  const showInEditor = root.dataset.showInEditor === 'true';
  const postedSuccessfully = root.dataset.postedSuccessfully === 'true';
  const hasErrors = root.dataset.hasErrors === 'true';
  const inDesignMode = Boolean(window.Shopify && window.Shopify.designMode);

  function dismiss() {
    try {
      window.localStorage.setItem(STORAGE_KEY, '1');
    } catch (error) {
      // Ignore storage errors (private mode, etc.)
    }
    root.classList.remove('is-open');
    window.setTimeout(() => {
      root.hidden = true;
    }, 350);
  }

  function openPopup() {
    root.hidden = false;
    requestAnimationFrame(() => {
      root.classList.add('is-open');
      const emailInput = root.querySelector('input[type="email"]');
      if (emailInput && !inDesignMode) {
        emailInput.focus({ preventScroll: true });
      }
    });
  }

  function wasDismissed() {
    try {
      return window.localStorage.getItem(STORAGE_KEY) === '1';
    } catch (error) {
      return false;
    }
  }

  function cookieBannerVisible() {
    const cookieBanner = document.querySelector('[data-cookie-banner]');
    return Boolean(cookieBanner && !cookieBanner.hidden);
  }

  function scheduleOpen() {
    if (wasDismissed() && !postedSuccessfully && !inDesignMode) return;

    const attemptOpen = () => {
      if (cookieBannerVisible() && !inDesignMode) {
        window.setTimeout(attemptOpen, 500);
        return;
      }
      window.setTimeout(openPopup, delayMs);
    };

    attemptOpen();
  }

  root.querySelectorAll('[data-welcome-close]').forEach((element) => {
    element.addEventListener('click', dismiss);
  });

  root.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') dismiss();
  });

  if (postedSuccessfully) {
    try {
      window.localStorage.setItem(STORAGE_KEY, '1');
    } catch (error) {
      // Ignore storage errors
    }
    openPopup();
    const copyButton = root.querySelector('[data-welcome-copy]');
    const codeEl = root.querySelector('[data-welcome-code]');
    if (copyButton && codeEl) {
      copyButton.addEventListener('click', async () => {
        const code = codeEl.textContent.trim();
        try {
          await navigator.clipboard.writeText(code);
          const original = copyButton.textContent;
          copyButton.textContent = copyButton.dataset.copiedLabel || 'Copied';
          window.setTimeout(() => {
            copyButton.textContent = original;
          }, 2000);
        } catch (error) {
          // Fallback: select text if clipboard is blocked
          const range = document.createRange();
          range.selectNodeContents(codeEl);
          const selection = window.getSelection();
          selection.removeAllRanges();
          selection.addRange(range);
        }
      });
    }
    if (!inDesignMode) {
      window.setTimeout(dismiss, 10000);
    }
    return;
  }

  if (hasErrors) {
    openPopup();
    return;
  }

  if (inDesignMode) {
    if (showInEditor) openPopup();
    return;
  }

  scheduleOpen();
})();
